<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row align-items-center mb-1">
        <div class="col-md-6">
          <div class="h2">{{routeName}}</div>
        </div>
        <div class="col-md-2 offset-md-4 text-right center">
          <router-link to="/admin/groups/list" class="btn btn-primary" role="button">
            back
          </router-link>
        </div>
      </div>
      <form @submit.prevent="update" v-if="group">
        <div class="row justify-content-md-center">
          <div class="col-12">
            <div class="row">
              <div class="col-md-12">
                <fg-input type="text"
                          v-model="group.groupTitle"
                          label="Group Title"
                          placeholder="Enter Title"
                          v-validate="rules.groupTitle"
                          data-vv-name="title"
                          cus-name="title"
                          :has-errors="errors"
                          :is-fields="fields">
                </fg-input>
              </div>
              <div class="col-md-12">
                <fg-input type="text"
                          v-model="group.groupDescription"
                          label="Group Description"
                          placeholder="Enter Description"
                          v-validate="rules.groupDescription"
                          data-vv-name="description"
                          cus-name="description"
                          :has-errors="errors"
                          :is-fields="fields">
                </fg-input>
              </div>
              <div class="col-12" v-if="interests.length">
                <label>Select Group Interests &nbsp;  <input type="checkbox" class="form-input" v-model="selectAllInterest"> Select All</label>
                <multiselect v-if="interests"
                             :disabled= "selectAllInterest"
                             v-model="selInterests"
                             placeholder="Select Interests"
                             :multiple="true"
                             :options="interests.map(type => type.interestId)"
                             :custom-label="opt => interests.find(x => x.interestId == opt).interest"
                             required>
                  >
                </multiselect>
              </div>
              <div class="col-12" v-if="experts.length">
                <label>Select Group Experts &nbsp;<input type="checkbox" class="form-input" v-model="selectAllExpert"> Select All
                </label>
                <multiselect
                  :disabled="selectAllExpert"
                  v-model="selExperts"
                  placeholder="Select Experts"
                  :multiple="true"
                  :options="experts.map(type => type.expertId)"
                  :custom-label="opt => experts.find(x => x.expertId == opt).name"
                  required>
                  >
                </multiselect>
              </div>
              <div class="col-12" v-if="tendingPlaylists.length">
                <label>Select Group Trending Playlists <input type="checkbox" class="form-input" v-model="selectAllPlaylists"> Select All</label>
                <multiselect
                  :disabled="selectAllPlaylists"
                  v-model="selPlaylists"
                  placeholder="Select Trending Playlists"
                  :multiple="true"
                  :options="tendingPlaylists.map(type => type.playlistId)"
                  :custom-label="opt => tendingPlaylists.find(x => x.playlistId == opt).playlistTitle"
                  required>
                  >
                </multiselect>
              </div>
              <div class="col-12" v-if="articles.length">
                <label>Select Group Articles&nbsp;<input type="checkbox" class="form-input" v-model="selectAllArticle"> Select All</label>
                <multiselect
                  :disabled="selectAllArticle"
                  v-model="selArticles"
                  placeholder="Select TONE Articles"
                  :multiple="true"
                  :options="articles.map(type => type.toneArticleId)"
                  :custom-label="opt => articles.find(x => x.toneArticleId == opt).articleHead"
                  required>
                  >
                </multiselect>
              </div>
              <div class="col-12" v-if="tags.length">
                <label>Select/Add Custom Tags</label>
                <multiselect v-if="tags"
                             v-model="selectedTags"
                             tag-placeholder="Add this as new Tag"
                             placeholder="Select or Add Tags"
                             :multiple="true"
                             :taggable="true"
                             @tag="addTag"
                             :options="tags"
                             required>
                  >
                </multiselect>
              </div>
              <div class="col-md-3" v-bind:style="{ color: group.headerColor}">
                <fg-input type="text"
                          v-model="group.headerColor"
                          label="Header Color"
                          placeholder="Enter Color Code"
                >
                </fg-input>
              </div>
              <div class="col-md-3" v-bind:style="{ color: group.footerColor}">
                <fg-input type="text"
                          v-model="group.footerColor"
                          label="Footer Color"
                          placeholder="Enter Color Code"
                >
                </fg-input>
              </div>
              <div class="col-md-3" v-bind:style="{ color: group.buttonColor}">
                <fg-input type="text"
                          v-model="group.buttonColor"
                          label="Button Color"
                          placeholder="Enter Color Code"
                >
                </fg-input>
              </div>
              <div class="col-md-3" v-bind:style="{ color: group.headingColor}">
                <fg-input type="text"
                          v-model="group.headingColor"
                          label="Heading Color"
                          placeholder="Enter Color Code"
                >
                </fg-input>
              </div>
              <div class="col-md-3" >
                <fg-input type="number" min="15"
                          v-model="group.minVidReqdWork"
                          label="Min Limit for Work Menu"
                          placeholder="Enter Number"
                >
                </fg-input>
              </div>
              <div class="col-md-3" >
                <fg-input type="number" min="15"
                          v-model="group.minVidReqdLife"
                          label="Min Limit for Life Menu"
                          placeholder="Enter Number"
                >
                </fg-input>
              </div>
              <div class="col-md-3" >
                <fg-input type="number" min="15"
                          v-model="group.minVidReqdMindBody"
                          label="Min Limit for Mindbody Menu"
                          placeholder="Enter Number"
                >
                </fg-input>
              </div>
              <div class="col-md-3" >
                <fg-input type="number" min="15"
                          v-model="group.minVidReqdMoney"
                          label="Min Limit for Money Menu"
                          placeholder="Enter Number"
                >
                </fg-input>
              </div>
              <div class="col-md-3" v-if="status.length">
                <fg-select
                  v-model="group.active"
                  label="Active"
                  v-validate="rules.active"
                  data-vv-name="active"
                  cus-name="active"
                  :has-errors="errors"
                  :is-fields="fields"
                  :list="status"
                  selectedKey="id"
                >
                </fg-select>
              </div>
            </div>
          </div>
          <div class="col-6 text-center">
            <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
              Update Group
            </button>
          </div>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import moment from 'moment'
  export default {
    name: 'EditGroup',
    created (){
      let self = this
      this.fetchInterests();
      this.fetchExperts();
      this.fetchTrendingPlaylists();
      this.fetchArticles();
      this.fetchTags();
      self.$store.dispatch('GET_SELECTED_GROUP', self.$route.params.id).then((res) => {
        if (self.group.selectAllInterest === 1) {
          self.selectAllInterest = true
          self.group.csvGroupInterestsId = null
          self.selInterests = []
        } else {
          // self.group.csvGroupInterestsId = self.group.csvGroupInterestsId.split(',')
          if (self.group.csvGroupInterestsId) {
            self.selInterests = self.group.csvGroupInterestsId.split(',')
          } else {
            self.selInterests = []
          }
        }
        if (self.group.selectAllExpert === 1) {
          self.selectAllExpert = true
          self.group.csvGroupExpertsId = null
          self.selExperts = []
        } else {
          if (self.group.csvGroupExpertsId) {
            self.selExperts = self.group.csvGroupExpertsId.split(',')
          } else {
            self.selExperts = []
          }
          // self.selExperts = self.group.csvGroupExpertsId.split(',')
          // self.group.csvGroupExpertsId = self.group.csvGroupExpertsId.split(',')
        }
        if (self.group.selectAllArticle === 1) {
          self.selectAllArticle = true
          self.group.csvGroupArticlesId = null
          self.selArticles = []
        } else {
          // self.group.csvGroupArticlesId = self.group.csvGroupArticlesId.split(',')
          if (self.group.csvGroupArticlesId) {
            self.selArticles = self.group.csvGroupArticlesId.split(',')
          } else {
            self.selArticles = []
          }
          // self.selArticles = self.group.csvGroupArticlesId.split(',')
        }
        if (self.group.selectAllTrendPlaylist === 1) {
          console.info(1)
          self.selectAllPlaylists = true
          self.group.csvGroupTrendPlaylistId = null
          self.selPlaylists = []
        } else {
          console.info(2)
          if (self.group.csvGroupTrendPlaylistId) {
            self.selPlaylists = self.group.csvGroupTrendPlaylistId.split(',')
          } else {
            self.selPlaylists = []
          }
          // self.group.csvGroupTrendPlaylistId = self.group.csvGroupArticlesId.split(',')
          // self.selPlaylists = self.group.csvGroupArticlesId.split(',')
        }
        self.selectedTags = self.group.csvGroupVideoTags.split(',')
        // self.group.csvGroupTrendPlaylistId = self.group.csvGroupTrendPlaylistId.split(',')
      })
    },
    data () {
      return {
        test: [],
        selectedTags: [],
        selInterests: [],
        selExperts: [],
        selPlaylists: [],
        selArticles: [],
        selectedCorpId: null,
        selectAllInterest: false,
        selectAllExpert: false,
        selectAllArticle: false,
        selectAllPlaylists: false,
        tags: [],
        corpIds: null,
        largeNewImage: [],
        smallNewImage: [],
        interests: [],
        experts: [],
        articles: [],
        tendingPlaylists: [],
        playlistString: '',
        corps: [],
//            playlist: null,
        status: [{name:'Select Status'}, {id:1, name:'Active'}, {id:0, name:'Inactive'}],
        rules: {
          groupTitle : {required: true},
          groupDescription: {required: true}
        }
      }
    },
    methods: {
      addTag (newTag) {
        let self = this
        console.log('newTAg', newTag)
        // let findTag = this.tags.filter (x => {
        //   return x.tagKey === newTag
        // })
          console.log('new tag', newTag)
          self.tags.push(newTag)
          self.selectedTags.push(newTag)
          // this.group.csvGroupVideoTags.push(tag)
          console.log('tagged', this.tags)
      },
      fetchInterests () {
        this.$store.dispatch('FETCH_INTERESTS_GROUP')
          .then((res) => {
            this.interests = res;
            console.log("interests : ", this.interests);
          })
          .catch(err => {
            console.log("API error : ", err);
          }),
          (err) => {
            console.log("err : ", err);
          }
      },
      fetchExperts () {
        this.$store.dispatch('FETCH_EXPERTS_GROUP')
          .then((res) => {
            this.experts = res;
            console.log("experts: ", this.experts);
          })
          .catch(err => {
            console.log("API error : ", err);
          }),
          (err) => {
            console.log("err : ", err);
          }
      },
      fetchTags () {
        this.$store.dispatch('FETCH_CUSTOM_TAGS')
          .then((res) => {
            let tags = res;
            if (tags) {
              console.log('all tags', tags)
              let uTags = tags.map(x => {
                return x.tagKey
              })
              this.tags = uTags
            }
            console.log("tags : ", this.tags);
          })
          .catch(err => {
            console.log("API error : ", err);
          }),
          (err) => {
            console.log("err : ", err);
          }
      },
      fetchArticles () {
        this.$store.dispatch('FETCH_ARTICLES_GROUP')
          .then((res) => {
            this.articles = res.payload;
            console.log("articles: ", this.articles);
          })
          .catch(err => {
            console.log("API error : ", err);
          }),
          (err) => {
            console.log("err : ", err);
          }
      },
      fetchTrendingPlaylists () {
        this.$store.dispatch('FETCH_TRENDING_PLAYLIST_GROUP')
          .then((res) => {
            this.tendingPlaylists = res.payload;
            console.log("trending playlists: ", this.tendingPlaylists);
          })
          .catch(err => {
            console.log("API error : ", err);
          }),
          (err) => {
            console.log("err : ", err);
          }
      },
      fetchCorporations () {
        this.$store.dispatch('FETCH_CORPORATIONS')
          .then((res) => {
            this.corps = res;
            console.log("this.corporations : ", this.corps);
          })
          .catch(err => {
            console.log("API error : ", err);
          }),
          (err) => {
            console.log("err : ", err);
          }
      },
      update () {
        this.$validator.validateAll().then((result) => {
          if(result){
            if (this.selectAllInterest) {
              this.group.selectAllInterest = 1
              this.group.csvGroupInterestsId = null
            } else {
              this.group.csvGroupInterestsId = this.selInterests ? this.selInterests.join(',') : null
              this.group.selectAllInterest = 0
            }
            if (this.selectAllExpert) {
              this.group.selectAllExpert = 1
              this.group.csvGroupExpertsId = null
            } else {
              this.group.csvGroupExpertsId = this.selExperts ? this.selExperts.join(',') : null
              this.group.selectAllExpert = 0
            }
            if (this.selectAllArticle) {
              this.group.selectAllArticle = 1
              this.group.csvGroupArticlesId = null
            } else {
              this.group.csvGroupArticlesId = this.selArticles ? this.selArticles.join(',') : null
              this.group.selectAllArticle = 0
            }
            if (this.selectAllPlaylists) {
              this.group.selectAllTrendPlaylist = 1
              this.group.csvGroupTrendPlaylistId = null
            } else {
              this.group.csvGroupTrendPlaylistId = this.selPlaylists ? this.selPlaylists.join(',') : null
              this.group.selectAllTrendPlaylist = 0
            }
            if (this.selectedTags && this.selectedTags.length > 0) {
              // let emailArray = this.selectedTags.map(x => {
              //   return x.tagKey
              // })
              this.group.csvGroupVideoTags = this.selectedTags.join(',')
            } else {
              this.group.csvGroupVideoTags = null
            }
            if (!this.group.headerColor || this.group.headerColor === '') {
              this.group.headerColor = '#f0617d'
            }
            if (!this.group.footerColor || this.group.footerColor === '') {
              this.group.footerColor = '#f0617d'
            }
            if (!this.group.buttonColor || this.group.buttonColor === '') {
              this.group.buttonColor = '#f0617d'
            }
            if (!this.group.headingColor || this.group.headingColor === '') {
              this.group.headingColor = '#f0617d'
            }
            console.log("this.group : ", this.group);
            let update = () =>{
              this.$store.dispatch('UPDATE_GROUP', this.group)
                .then((res) => {
                  console.log("UPDATE_GROUP res : ", res);
                  this.showPopup('Success!', 'Corporation Group is successfully updated', 'success', ()=>this.$router.push('/admin/groups'))
                })
                .catch(err => {
                  this.showPopup('Error!', 'some thing happen wrong', 'error')
                  console.log("UPDATE_GROUP API error : ", err);
                })
            };
            update();
          }
        })
      },
      showPopup(title, msg, popupType, cb){
        this.$swal( title, msg, popupType
        ).then(res => {
          cb && cb();
          return res
        })
      },
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      updateLargeImg(data){
        this.corporation.largeImage = data.path;
        this.largeNewImage = data.value;
        console.log("updateLargeImg data : ", data);
      },
      updateSmallImg(data){
        this.corporation.smallImage = data.path;
        this.smallNewImage = data.value;
        console.log("updateSmallImg data : ", data);
      },
    },
    computed: {
      ...mapGetters([ 'corporations', 'selectedGroup']),
      routeName () {
        const {name} = this.$route;
        return this.capitalizeFirstLetter(name);
      },
      group(){
        return this.selectedGroup
      }
    }
  }
</script>

<style>
  .form-control{
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Groups/EditGroup.vue